import React from 'react';
import { Wallet } from 'lucide-react';

const ConnectWalletButton: React.FC = () => {
  return (
    <button
      disabled
      className="
        flex items-center space-x-2
        bg-[#1f1f1f]
        px-6 py-2
        font-semibold
        text-gray-400
        border border-[#1a1a1a]
        cursor-not-allowed
        opacity-75
        hover:bg-[#2a2a2a]
        transition-colors
      "
    >
      <Wallet className="w-4 h-4" />
      <span>Connect Wallet</span>
    </button>
  );
};

export default ConnectWalletButton;